import {getDefaultState} from '@/store/modules/menu/state'

export const SET_DEMO = 'SET_DEMO'
export const RESET_STATE = 'RESET_STATE'
export const SET_MENU_BASIC_INFO = 'SET_MENU_BASIC_INFO'
export const SET_MENU_DETAIL = 'SET_MENU_DETAIL'

export default {
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  },
  [SET_MENU_BASIC_INFO](state, payload) {
    state.menuBasicInfo = payload
  },
  [SET_MENU_DETAIL](state, menuDetail) {
    state.menuDetail = menuDetail
  }

}